module.exports = __webpack_public_path__ + "img/shenlan.bd5ef23b.png";